<template>
  <div class="view">
    <Title title="お知らせ"/>
    <InfoNewMain />
  </div>
</template>

<script>
import Title from '@/components/Title.vue'
import InfoNewMain from '@/components/Info/NewMain'

export default {
  components: {
    Title,
    InfoNewMain
  }
}
</script>
